module.exports = __webpack_public_path__ + "img/app_icn.13cb98d1.png";